var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 335,
    viewBox: "0 0 123 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.669 274.492C122.669 307.667 95.2006 334.553 61.3355 334.553C27.4704 334.553 0 307.654 0 274.492C0 250.896 13.8954 230.476 34.1105 220.655V26.8794C34.081 23.3601 34.7634 19.8698 36.1184 16.61C37.4733 13.3502 39.4739 10.3854 42.0048 7.88656C44.5357 5.38773 47.5469 3.40436 50.8645 2.05085C54.1821 0.697342 57.7406 0.000488281 61.3346 0.000488281C64.9286 0.000488281 68.4871 0.697342 71.8047 2.05085C75.1223 3.40436 78.1335 5.38773 80.6644 7.88656C83.1953 10.3854 85.1959 13.3502 86.5509 16.61C87.9058 19.8698 88.5882 23.3601 88.5587 26.8794V220.655C108.774 230.474 122.669 250.896 122.669 274.492Z",
    fill: "#CADDDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.89 274.486C110.89 301.28 88.7122 323 61.348 323C33.9838 323 11.8057 301.28 11.8057 274.486C11.8057 254.401 24.2709 237.166 42.0394 229.796V180.356H80.6566V229.796C98.4251 237.166 110.89 254.401 110.89 274.486Z",
    fill: "#43CBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0371 180.359V27.4372C42.0371 22.422 44.0716 17.6122 47.693 14.0659C51.3144 10.5196 56.2261 8.52734 61.3475 8.52734C66.469 8.52734 71.3806 10.5196 75.0021 14.0659C78.6235 17.6122 80.6579 22.422 80.6579 27.4372V180.359H42.0371Z",
    fill: "#43CBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6481 27.4402V180.362H68.9464V26.5526C68.9464 20.2619 65.5 10.3757 53.0146 10.3757C55.9584 8.99797 59.2107 8.37316 62.4679 8.55956C65.725 8.74595 68.8808 9.73748 71.6407 11.4416C74.4006 13.1457 76.6745 15.5068 78.2503 18.3045C79.8261 21.1022 80.6523 24.2452 80.6517 27.4402H80.6481Z",
    fill: "#43CBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 30.9561H66.6494V32.8605H76.7267V30.9561Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 47.4824H66.6494V49.3869H76.7267V47.4824Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 35.0239H71.7676V35.9797H76.7174V35.0239Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 38.1387H71.7676V39.0945H76.7174V38.1387Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 41.2529H71.7676V42.2087H76.7174V41.2529Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 44.3672H71.7676V45.323H76.7174V44.3672Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 64.0137H66.6494V65.9181H76.7267V64.0137Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 51.5444H71.7676V52.5002H76.7174V51.5444Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 54.6646H71.7676V55.6204H76.7174V54.6646Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 57.7896H71.7676V58.7454H76.7174V57.7896Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 60.9048H71.7676V61.8606H76.7174V60.9048Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 80.5508H66.6494V82.4552H76.7267V80.5508Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 68.0869H71.7676V69.0427H76.7174V68.0869Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 71.1963H71.7676V72.1521H76.7174V71.1963Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 74.3159H71.7676V75.2717H76.7174V74.3159Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 77.4307H71.7676V78.3865H76.7174V77.4307Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 97.0767H66.6494V98.9811H76.7267V97.0767Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 84.6133H71.7676V85.5691H76.7174V84.6133Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 87.7275H71.7676V88.6833H76.7174V87.7275Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 90.8481H71.7676V91.804H76.7174V90.8481Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 93.9683H71.7676V94.9241H76.7174V93.9683Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 113.609H66.6494V115.513H76.7267V113.609Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 101.145H71.7676V102.1H76.7174V101.145Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 104.26H71.7676V105.216H76.7174V104.26Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 107.374H71.7676V108.33H76.7174V107.374Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 110.495H71.7676V111.45H76.7174V110.495Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 130.146H66.6494V132.05H76.7267V130.146Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 117.676H71.7676V118.632H76.7174V117.676Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 120.791H71.7676V121.746H76.7174V120.791Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 123.911H71.7676V124.867H76.7174V123.911Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 127.025H71.7676V127.981H76.7174V127.025Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 146.672H66.6494V148.576H76.7267V146.672Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 134.208H71.7676V135.164H76.7174V134.208Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 137.323H71.7676V138.279H76.7174V137.323Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 140.443H71.7676V141.399H76.7174V140.443Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 143.558H71.7676V144.513H76.7174V143.558Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 163.204H66.6494V165.108H76.7267V163.204Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 150.739H71.7676V151.695H76.7174V150.739Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 153.854H71.7676V154.81H76.7174V153.854Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 156.963H71.7676V157.919H76.7174V156.963Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 160.083H71.7676V161.039H76.7174V160.083Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 179.73H66.6494V181.634H76.7267V179.73Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 167.271H71.7676V168.227H76.7174V167.271Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 170.38H71.7676V171.336H76.7174V170.38Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 173.506H71.7676V174.462H76.7174V173.506Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 176.62H71.7676V177.576H76.7174V176.62Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 196.261H66.6494V198.165H76.7267V196.261Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 183.803H71.7676V184.759H76.7174V183.803Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 186.912H71.7676V187.867H76.7174V186.912Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 190.032H71.7676V190.988H76.7174V190.032Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 193.146H71.7676V194.102H76.7174V193.146Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7267 212.793H66.6494V214.697H76.7267V212.793Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 200.334H71.7676V201.29H76.7174V200.334Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 203.455H71.7676V204.41H76.7174V203.455Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 206.558H71.7676V207.514H76.7174V206.558Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 209.683H71.7676V210.639H76.7174V209.683Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCold);
export default __webpack_public_path__ + "static/media/cold.fb60b8cf6af195f9d93e59d0657c8c93.svg";
export { ForwardRef as ReactComponent };